import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classes from "src/theme/classes";

// JSS Classes Hook
const useClasses = makeStyles((theme: Theme) => createStyles(classes(theme)))

export default useClasses;